import {
  paths,
  settingsResponseSchema,
  type Settings,
  type SettingsResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

/** 整份覆盖：契约的 PUT 不做部分更新，页面每次提交完整配置。 */
export const putSettingsOperation = "settings.save";

export type PutSettingsOperation = typeof putSettingsOperation;

export type PutSettingsFailure = BackendFailure<PutSettingsOperation>;

export function putSettings(
  settings: Settings,
  options: { fetch?: typeof globalThis.fetch; signal?: AbortSignal } = {},
): ResultAsync<SettingsResponse, PutSettingsFailure> {
  return requestBackendResult({
    body: settings,
    fetch: options.fetch,
    method: "PUT",
    operation: putSettingsOperation,
    parse: (payload) => settingsResponseSchema.parse(payload),
    path: paths.settings,
    signal: options.signal,
  });
}
